<template>
  <div class="uploadfile">
    <textarea v-model="textmodle" placeholder="在此粘贴磅单短信内容,点击「解析短信」即可解析多条记录" rows="10"
      style="width: 100%; margin-bottom: 20px;"></textarea>

    <div class="upload-actions">
      <el-button type="primary" @click="clearFiles">清空内容</el-button>
      <el-button type="success" @click="textmodlefun">解析短信</el-button>
      <el-button v-if="parsedRecords.length > 0" type="primary" @click="exportParsedCSV">导出信息</el-button>
    </div>

    <div v-if="parsedRecords && parsedRecords.length > 0" class="data-preview" style="margin-top:20px;">
      <el-card header="短信解析结果预览">
        <el-table :data="parsedRecords" style="width: 100%">
          <el-table-column prop="id" label="编号" width="80" />
          <el-table-column prop="date" label="日期" width="180" />
          <el-table-column prop="carnumber" label="车号" width="120" />
          <el-table-column prop="customname" label="客户名称" />
          <el-table-column prop="lever" label="等级" width="120" />
          <el-table-column prop="heavey" label="结算重量(吨)" width="120" />
          <el-table-column prop="price" label="单价" width="100" />
          <el-table-column prop="deductweight" label="扣重(吨)" width="120" />
          <el-table-column prop="deductprice" label="扣款(元)" width="120" />
          <el-table-column prop="payfreight" label="代付运费" width="120" />
          <el-table-column prop="paymentamount" label="预付款" width="120" />
          <el-table-column prop="paymentMoney" label="付款金额" width="120" />
        </el-table>
      </el-card>
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus';

import request from '@/api/api.js';

export default {
  name: 'uploadfile',
  data() {
    return {
      textmodle: '',
      parsedRecords: []
    }
  },
  methods: {
    textmodlefun() {
      const text = this.textmodle || ''

      if (!text.trim()) {
        this.parsedRecords = []
        ElMessage.error('请输入短信文本')
        return []
      }

      // 根据短信头拆分成多条记录(保留头本身)
      const blocks = text.split(/(?=【福建省三钢】)/).map(s => s.trim()).filter(Boolean)
      const results = []
      let idx = 0

      for (const blk of blocks) {
        idx += 1
        try {
          // 客户名称
            const customname=''
          // const customMatch = blk.match(/【[^】]+】\s*([^\n::]+)/)
          // const customname = customMatch ? customMatch[1].replace(/您好[::]?$/, '').trim() : ''
          // if (!customname.includes("三明市八闽废旧物资回收有限公司")) {
          //   ElMessage.warning(`名称提取失败,请检查第${idx}条文本内容`)
          // };

          // 日期
          const dateMatch = blk.match(/您于\s*(\d{4}-\d{2}-\d{2}\s*\d{2}:\d{2}:\d{2})/)
          const date = dateMatch ? dateMatch[1].trim().slice(0, 10) : ''

          if (date == "") {
            ElMessage.warning(`日期提取失败,请检查第${idx}条文本内容`)
          };


          // 磅单号
          // const poundMatch = blk.match(/磅单号[::]?\s*([^\s,,.]+)/)
          // const poundId = poundMatch ? poundMatch[1].trim() : ''
          // if (poundId == "") {
          //   ElMessage.warning(`磅单号提取失败,请检查第${idx}条文本内容`)
          // };

          // 车号(有时写作"过磅的车号为闽GB1212的车")
          let carMatch = blk.match(/(?:车号|过磅的车号(?:为)?)[::]?\s*([^\s,,.]+)/)
          let carnumber = carMatch ? carMatch[1].trim() : ''
          // 去掉末尾可能的"的车"或多余文字
          carnumber = carnumber.replace(/的?车$/, '')
          if (carnumber == "") {
            ElMessage.warning(`车号提取失败,请检查第${idx}条文本内容`)
          };
          // 净重
          const netMatch = blk.match(/净重[::]?\s*([\d.]+)\s*吨/)

          const netWeight = netMatch ? parseFloat(netMatch[1]) : null
          // if (netMatch == null) {
          //   ElMessage.warning(`净重提取失败,请检查第${idx}条文本内容`)
          // };
          // 等级与等级重量
          const leverMatch = blk.match(/等级[::]?\s*([^,,.\n]+)/)
          const lever = leverMatch ? leverMatch[1].trim() : ''
          if (lever == '') {
            ElMessage.warning(`等级提取失败,请检查第${idx}条文本内容`)
          };
          const levelWMatch = blk.match(/等级重量[::]?\s*([\d.]+)\s*吨/)
          const levelWeight = levelWMatch ? parseFloat(levelWMatch[1]) : null
          if (levelWeight == null) {
            ElMessage.warning(`重量提取失败,请检查第${idx}条文本内容`)
          };

          // 总扣重 / 总扣款
          const deductWMatch = blk.match(/总共扣重[::]?\s*([\d.]+)\s*吨/)
          const deductweight = deductWMatch ? parseFloat(deductWMatch[1]) : 0
          if (deductweight == 0) {
            ElMessage.warning(`扣重提取失败,请检查第${idx}条文本内容`)
          };
          const deductPMatch = blk.match(/总共扣款[::]?\s*([\d.]+)\s*元/)
          const deductprice = deductPMatch ? Math.round(parseFloat(deductPMatch[1])) : 0
          if (deductweight == 0) {
            ElMessage.warning(`扣款提取失败,请检查第${idx}条文本内容`)
          };

          // 结算重量优先使用净重(用户要求)
          const heavey =levelWeight

          results.push({
            id: idx,
            date,
            carnumber,
            customname,
            lever,
            heavey: isNaN(heavey) ? 0 : heavey,
            levelWeight: isNaN(levelWeight) ? 0 : levelWeight,
            price: 0,
            deductweight: isNaN(deductweight) ? 0 : deductweight,
            deductprice: isNaN(deductprice) ? 0 : deductprice,
            payfreight: 0,
            paymentamount: 0,
            paymentMoney: 0
          })
          this.rice=results
        } catch (e) {
          console.error('解析单条短信失败', e)
        }
      }

      this.parsedRecords = results
      if (results.length === 0) ElMessage.info('未匹配到任何记录,请检查文本格式')
      else ElMessage.success(`解析到 ${results.length} 条记录`)
      return results
    },
    clearFiles() {
      this.textmodle = ''
      this.parsedRecords = []
    },

    async exportParsedCSV() {
      if (!this.parsedRecords || this.parsedRecords.length === 0) {
        ElMessage.warning('没有可导出的解析结果')
        return
      }

      const columns = [
        { key: 'id', label: '编号' },
        { key: 'date', label: '日期' },
        { key: 'carnumber', label: '车号' },
        { key: 'customname', label: '客户名称' },
        { key: 'lever', label: '等级' },
        { key: 'heavey', label: '结算重量' },
        { key: 'price', label: '单价' },
        { key: 'deductweight', label: '扣重' },
        { key: 'deductprice', label: '扣款' },
        { key: 'payfreight', label: '代付运费' },
        { key: 'paymentamount', label: '预付款' },
        { key: 'paymentMoney', label: '付款金额' }
      ]

      const escapeCell = (val) => {
        if (val === null || val === undefined) return ''
        let s = String(val)
        if (s.includes('"')) s = s.replace(/"/g, '""')
        if (s.includes(',') || s.includes('"') || s.includes('\n')) {
          return `"${s}"`
        }
        return s
      }

      const headerRow = columns.map(c => c.label).join(',')
      const rows = this.parsedRecords.map(r => columns.map(c => escapeCell(r[c.key])).join(','))
      const csv = '\uFEFF' + [headerRow, ...rows].join('\n')

      try {
        const filename = `parsed_records_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.csv`
        
        const response = await request('/TenderEntity/uploadlogcvsdibanmasssge', 'post', {
              title: filename,
              dibanMassageVoList:  this.rice, // 从索引2开始到结尾的所有元素
      
            })
            console.log(response,'response');
            
            
            const base64Data = response.data.data.toString().trim().replace(/\s/g, '')
            this.downloadFileFromBase64(base64Data, filename)

        // const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        // const url = window.URL.createObjectURL(blob)
        // const link = document.createElement('a')
        // link.href = url
        // const filename = `parsed_records_${new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-')}.csv`
        // link.download = filename
        // document.body.appendChild(link)
        // link.click()
        // document.body.removeChild(link)
        // window.URL.revokeObjectURL(url)
        // ElMessage.success('CSV 已下载')
      } catch (e) {
        console.error('导出 CSV 失败', e)
        ElMessage.error('导出 CSV 失败')
      }
    },
      downloadFileFromBase64(base64Data, filename) {
      try {
        console.log('📥 开始下载文件:', filename)
        console.log('📱 设备信息:', {
          userAgent: navigator.userAgent,
          isMobile: this.isMobile,
          isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
          isAndroid: /Android/.test(navigator.userAgent)
        })
        
        // 检测文件类型
        let mimeType = 'application/octet-stream'
        let fileExtension = '.csv'
        
        // 根据 base64 数据头判断文件类型
        if (base64Data.startsWith('data:')) {
          // 如果包含 data URL 前缀,提取 MIME 类型
          const mimeMatch = base64Data.match(/^data:([^;]+);base64,/)
          if (mimeMatch) {
            mimeType = mimeMatch[1]
            base64Data = base64Data.replace(/^data:[^;]+;base64,/, '')
            
            // 根据 MIME 类型确定文件扩展名
            if (mimeType.includes('csv')) {
              fileExtension = '.csv'
            } else if (mimeType.includes('excel') || mimeType.includes('spreadsheet')) {
              fileExtension = '.xlsx'
            } else if (mimeType.includes('pdf')) {
              fileExtension = '.pdf'
            }
          }
        }
        
        // 确保文件名有正确的扩展名
        if (!filename.includes('.')) {
          filename += fileExtension
        }
        
        console.log('📄 文件信息:', {
          filename: filename,
          mimeType: mimeType,
          base64Length: base64Data.length
        })
        
        // 根据设备类型选择下载方式
        if (this.isMobile) {
          this.downloadForMobile(base64Data, filename, mimeType)
        } else {
          this.downloadForDesktop(base64Data, filename, mimeType)
        }
        
      } catch (error) {
        console.error('❌ 文件下载失败:', error)
        ElMessage.error('文件下载失败: ' + error.message)
      }
    },

    // 桌面端下载方法
    downloadForDesktop(base64Data, filename, mimeType) {
      try {
        // 将 base64 转换为 Blob
        const byteCharacters = atob(base64Data)
        const byteNumbers = new Array(byteCharacters.length)
        
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i)
        }
        
        const byteArray = new Uint8Array(byteNumbers)
        const blob = new Blob([byteArray], { type: mimeType })
        
        // 创建下载链接
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        link.style.display = 'none'
        
        // 触发下载
        document.body.appendChild(link)
        link.click()
        
        // 清理
        setTimeout(() => {
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }, 1000)
        
        console.log('✅ 桌面端文件下载完成:', filename)
        ElMessage.success('文件下载成功!')
        
      } catch (error) {
        console.error('❌ 桌面端下载失败:', error)
        ElMessage.error('桌面端下载失败: ' + error.message)
      }
    },

  }
}
</script>

<style lang="less" scoped>
.uploadfile {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

.upload-actions {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.data-preview {
  margin-top: 20px;
}

:deep(.el-upload-dragger) {
  width: 100%;
  height: 180px;
}
</style>